import {
  baseRoutePath,
  createWorkOrderSuccess,
  loadBuildingSuccess,
} from '../work-orders';
import WorkOrdersApi from '../../../../services/api/work-orders-api';
import BuildingsApi from '../../../../services/api/buildings-api';
import LocationsApi from '../../../../services/api/locations-api';
import { push } from 'react-router-redux';
import {
  WORK_ORDERS_CREATION_BUILDING_DOCUMENTS_REMOVE_SUCCESS,
  WORK_ORDERS_CREATION_BUILDING_DOCUMENTS_UPLOAD_SUCCESS,
  WORK_ORDERS_CREATION_BUILDING_LOCATION_UPDATE_SUCCESS,
  WORK_ORDERS_CREATION_BUILDING_UPDATE_SUCCESS,
  WORK_ORDERS_CREATION_NEW_BUILDING_CHANGE_VALUE,
  WORK_ORDERS_CREATION_NEW_BUILDING_EDIT,
  WORK_ORDERS_CREATION_NEW_BUILDING_REQUEST,
  WORK_ORDERS_CREATION_NEW_BUILDING_SUCCESS,
  WORK_ORDERS_CREATION_SELECT_BUILDING,
} from '../action-types';
import { showErrorMessage } from '../../../messages';
import { goToTasks } from './creation';

export function loadBuildingsRequest(clientId) {
  return (dispatch) => {
    return BuildingsApi.getBuildings(clientId).then((response) => {
      if (response.ok) {
        dispatch(loadBuildingSuccess(response.buildings));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function createWorkOrderRequest(buildingId, currentWorkOrder, clientId) {
  return (dispatch) => {
    dispatch(selectBuilding(buildingId));

    if (currentWorkOrder !== null) {
      // Editing the current work order creation
      return WorkOrdersApi.updateBuilding(currentWorkOrder.id, buildingId).then(
        (response) => {
          if (response.ok) {
            dispatch(createWorkOrderSuccess(response.workOrder));
            dispatch(goToTasks());
          } else {
            dispatch(showErrorMessage(response.errors));
          }
        }
      );
    } else {
      return WorkOrdersApi.createWorkOrder(buildingId, clientId).then(
        (response) => {
          if (response.ok) {
            dispatch(createWorkOrderSuccess(response.newWorkOrder));
            dispatch(push(baseRoutePath + '/work-order-created'));
          } else {
            dispatch(showErrorMessage(response.errors));
          }
        }
      );
    }
  };
}

export function selectBuilding(buildingId) {
  return {
    type: WORK_ORDERS_CREATION_SELECT_BUILDING,
    payload: buildingId,
  };
}

export function goToNewBuilding() {
  return (dispatch) => {
    dispatch({
      type: WORK_ORDERS_CREATION_NEW_BUILDING_REQUEST,
    });
    dispatch(push(baseRoutePath + '/new-building'));
  };
}

export function newBuildingChange(attribute, value) {
  return {
    type: WORK_ORDERS_CREATION_NEW_BUILDING_CHANGE_VALUE,
    payload: { attribute, value },
  };
}

export function editNewBuilding() {
  return {
    type: WORK_ORDERS_CREATION_NEW_BUILDING_EDIT,
  };
}

export function createBuildingRequest(newBuilding, clientId) {
  return (dispatch) => {
    const data = {
      location: {
        streetAddress: newBuilding.streetAddress,
        city: newBuilding.city,
        state: newBuilding.state,
        zipCode: newBuilding.zipCode,
      },
    };

    if (newBuilding.name !== '') {
      data['name'] = newBuilding.name;
    }

    if (newBuilding.unitNumber !== '') {
      data['location']['unitNumber'] = newBuilding.unitNumber;
    }

    if (clientId !== undefined) {
      data['clientsId'] = [clientId];
    }

    return BuildingsApi.createBuilding(data).then((response) => {
      if (response.ok) {
        dispatch(createBuildingSuccess(response.building));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function createBuildingSuccess(newBuilding) {
  return {
    type: WORK_ORDERS_CREATION_NEW_BUILDING_SUCCESS,
    payload: newBuilding,
  };
}

export function updateBuildingRequest(
  buildingId,
  locationId,
  data,
  currentWorkOrder,
  clientId
) {
  return (dispatch) => {
    dispatch(selectBuilding(buildingId));
    return BuildingsApi.updateBuildingNameAndLocation(
      buildingId,
      locationId,
      data
    ).then((response) => {
      if (response.ok) {
        dispatch(updateBuildingSuccess(response.newBuilding));

        if (currentWorkOrder !== null) {
          // Update current work order with the new building created
          return WorkOrdersApi.updateBuilding(
            currentWorkOrder.id,
            buildingId
          ).then((response) => {
            if (response.ok) {
              dispatch(createWorkOrderSuccess(response.workOrder));
              dispatch(goToTasks());
            } else {
              dispatch(showErrorMessage(response.errors));
            }
          });
        } else {
          return WorkOrdersApi.createWorkOrder(buildingId, clientId).then(
            (response) => {
              if (response.ok) {
                dispatch(createWorkOrderSuccess(response.newWorkOrder));
                dispatch(push(baseRoutePath + '/work-order-created'));
              } else {
                dispatch(showErrorMessage(response.errors));
              }
            }
          );
        }
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function updateBuildingSuccess(building) {
  return {
    type: WORK_ORDERS_CREATION_BUILDING_UPDATE_SUCCESS,
    payload: building,
  };
}

export function updateLocationRequest(selectedBuildingId, latitude, longitude) {
  return (dispatch) => {
    return LocationsApi.getLocationByLatLong(latitude, longitude).then(
      (response) => {
        if (response.ok) {
          dispatch(
            updateLocationRequestSuccess(
              selectedBuildingId,
              latitude,
              longitude,
              response.location
            )
          );
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      }
    );
  };
}

export function updateLocationRequestSuccess(
  selectedBuildingId,
  latitude,
  longitude,
  location
) {
  return {
    type: WORK_ORDERS_CREATION_BUILDING_LOCATION_UPDATE_SUCCESS,
    payload: { selectedBuildingId, latitude, longitude, location },
  };
}

export function uploadDocumentsRequest(buildingId, files) {
  return (dispatch) => {
    return BuildingsApi.uploadDocuments(buildingId, files).then((response) => {
      if (response.ok) {
        dispatch(uploadDocumentsSuccess(response.building));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function uploadDocumentsSuccess(building) {
  return {
    type: WORK_ORDERS_CREATION_BUILDING_DOCUMENTS_UPLOAD_SUCCESS,
    payload: building,
  };
}

export function removeDocumentRequest(buildingId, documentId) {
  return (dispatch) => {
    return BuildingsApi.deleteDocument(buildingId, documentId).then(
      (response) => {
        if (response.ok) {
          dispatch(removeDocumentSuccess(response.building));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      }
    );
  };
}

export function removeDocumentSuccess(building) {
  return {
    type: WORK_ORDERS_CREATION_BUILDING_DOCUMENTS_REMOVE_SUCCESS,
    payload: building,
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin/work-orders/creation/buildings.js